import { useMemo } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '~/redux/actions/reviews'
import {
  getReviewsAllReviews,
  getReviewsAllStats,
  getReviewsProductsReviews,
  getReviewsProductsStats,
  getReviewsSiteStats,
} from '~/redux/selectors/reviews'

export function useReviews() {
  const dispatch = useDispatch()
  const allReviews = useSelector(getReviewsAllReviews)
  const allStats = useSelector(getReviewsAllStats)
  const productsReviews = useSelector(getReviewsProductsReviews)
  const productsStats = useSelector(getReviewsProductsStats)
  const siteStats = useSelector(getReviewsSiteStats)

  const getAllReviews = () => {
    if (typeof window !== 'undefined') fetchAllReviews()
    return allReviews
  }

  const getAllStats = () => allStats

  const getProductReviews = (id) => {
    if (typeof window !== 'undefined') fetchProductReviews(id)
    return productsReviews?.[id]
  }

  const getProductStats = (id) => {
    if (typeof window !== 'undefined') fetchReviewsProductsStats()
    return productsStats?.[id]
  }

  const getSiteStats = () => {
    if (typeof window !== 'undefined') fetchReviewsSiteStats()
    return siteStats
  }

  const fetchAllReviews = useMemo(
    () => bindActionCreators(actions.fetchAllReviews, dispatch),
    [dispatch]
  )

  const fetchProductReviews = useMemo(
    () => bindActionCreators(actions.fetchProductReviews, dispatch),
    [dispatch]
  )

  const fetchReviewsProductsStats = useMemo(
    () => bindActionCreators(actions.fetchReviewsProductsStats, dispatch),
    [dispatch]
  )

  const fetchReviewsSiteStats = useMemo(
    () => bindActionCreators(actions.fetchReviewsSiteStats, dispatch),
    [dispatch]
  )

  return {
    getAllReviews,
    getAllStats,
    getProductReviews,
    getProductStats,
    getSiteStats,
  }
}
